/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';



export interface ComponentServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Fetches the component-Config based on ComponentType
     * Fetches the component-Config based on ComponentType
     * @param componentType type of the component
     */
    getComponentConfig(componentType: string, extraHttpRequestParams?: any): Observable<string>;

}
